/* eslint-disable */
import { UpfrontPaymentSummary } from '../models/upfront.payment.summary.model';
import { Status, Description } from '../models/service.model';

export const mockUpfrontPayment: UpfrontPaymentSummary = {
  make: 'Indesit',
  model: 'IWDC6125',
  applianceCategory: 'Washer Dryer',
  upgradeFee: 0,
  isProtectionSelected: false,
  monthlyPayment: 6.49,
  replacementCost: 0,
  isInstallationSelected: true,
  isInstallationAvailable: true,
  installation: {
    charge_type: 2,
    cat_num: 'INSSTD',
    status: Status.F,
    description: Description.Installation,
    price_net: 0,
    price_gross: 0,
    charge_customer: false,
  },
  isDisposalSelected: true,
  isDisposalAvailable: true,
  disposal: {
    charge_type: 3,
    cat_num: 'REMSTD',
    status: Status.F,
    description: Description.Disposal,
    price_net: 0,
    price_gross: 0,
    charge_customer: false,
  },
  isDeliverySelected: true,
  isDeliveryAvailable: true,
  delivery: {
    cat_num: 'DELRGB',
    charge_type: 1,
    status: Status.F,
    description: Description.Delivery,
    price_net: 0,
    price_gross: 0,
    charge_customer: false,
  },
  outstandingPlanAmount: 0,
  outstandingMonthlyPayments: 0,
  jobReferenceNumber: '1234',
  offerType: 'Standard',
};

export const mockUpfrontPaymentProtection: UpfrontPaymentSummary = {
  make: 'Indesit',
  model: 'IWDC6125',
  applianceCategory: 'Washer Dryer',
  upgradeFee: 0,
  isProtectionSelected: true,
  monthlyPayment: 6.49,
  replacementCost: 0,
  isInstallationSelected: true,
  isInstallationAvailable: true,
  installation: {
    charge_type: 2,
    cat_num: 'INSSTD',
    status: Status.F,
    description: Description.Installation,
    price_net: 0,
    price_gross: 0,
    charge_customer: false,
  },
  isDisposalSelected: true,
  isDisposalAvailable: true,
  disposal: {
    charge_type: 3,
    cat_num: 'REMSTD',
    status: Status.F,
    description: Description.Disposal,
    price_net: 0,
    price_gross: 0,
    charge_customer: false,
  },
  isDeliverySelected: true,
  isDeliveryAvailable: true,
  delivery: {
    cat_num: 'DELRGB',
    charge_type: 1,
    status: Status.F,
    description: Description.Delivery,
    price_net: 0,
    price_gross: 0,
    charge_customer: false,
  },
  outstandingPlanAmount: 0,
  outstandingMonthlyPayments: 0,
  jobReferenceNumber: '1234',
  offerType: 'Standard',
};
